<script lang="ts" setup>
import { useFetchWrapper } from "@composables"
import { Services } from "@types"
import { inject, onBeforeMount } from "vue"
import { useRoute, useRouter } from "vue-router"
const router = useRouter()
const route = useRoute()

const { $unsubscribeMails } = inject<Services>("services")!

onBeforeMount(() => {
    // si pas de query email, on redirige vers la page d'accueil
    if (!route.query.email) {
        console.error("Email parameter is missing in the route")
        router.push("/")
    }
})

const fetchUnsubscribe = useFetchWrapper(async () => {
    // Récupère l'email de l'utilisateur à partir des paramètres de la route
    const email = route.query.email as string
    if (!email) {
        console.error("Email parameter is missing in the route")
        return
    }

    // Call the unsubscribe service
    await $unsubscribeMails(email)
    // Redirect to a confirmation page or show a message

    router.push({
        query: {
            success: "true",
        },
    })
})
</script>
<template>
    <div class="unsubscribe-page">
        <!-- Unsubscribe page content goes here -->
        <BaseCard>
            <template #title>
                <h1 class="text-center">
                    {{
                        $route.query.success
                            ? "Vous êtes désabonné"
                            : "Désabonnement des mails WattWatchers"
                    }}
                </h1>
            </template>
            <template #content>
                <div
                    class="flex flex-col gap-4 max-w-[30rem] mx-auto"
                    v-if="!$route.query.success"
                >
                    <p>
                        Si vous souhaitez vous désabonner de notre service,
                        veuillez cliquer sur le bouton ci-dessous :
                    </p>
                    <BaseButton
                        type="button"
                        @click="fetchUnsubscribe.fetch()"
                        :loading="fetchUnsubscribe.isFetching.value"
                    >
                        Se désabonner
                    </BaseButton>
                    <p>Merci d'avoir été avec nous !</p>
                    <BaseButton
                        as-child
                        v-slot="slotProps"
                        link
                        size="small"
                        :disabled="fetchUnsubscribe.isFetching.value"
                    >
                        <RouterLink
                            to="/"
                            :class="slotProps.class"
                            class="button-link"
                            >Retour à l'accueil</RouterLink
                        >
                    </BaseButton>
                    <BaseMessage
                        v-if="fetchUnsubscribe.hasError.value"
                        severity="error"
                    >
                        Une erreur est survenue lors de la tentative de
                        désabonnement. Veuillez réessayer plus tard.
                    </BaseMessage>
                </div>
                <div v-else class="flex flex-col gap-4 max-w-[30rem] mx-auto">
                    <p>Vous avez été désabonné avec succès.</p>
                    <BaseButton as-child v-slot="slotProps" link size="small">
                        <RouterLink
                            to="/"
                            :class="slotProps.class"
                            class="button-link"
                            >Retour à l'accueil</RouterLink
                        >
                    </BaseButton>
                </div>
            </template>
        </BaseCard>
    </div>
</template>

<style scoped>
.unsubscribe-page {
    display: flex;
    width: 100%;
    max-width: 40rem;
    margin: 0 auto;
    flex-direction: column;
    gap: 4rem;

    flex: 1;
}

.button-link {
    color: #000000;
}
</style>
